/**
 * @export
 * @class RefundRule
 * 취소/환불정보
 */
export default class RefundRule {
  constructor() {
    // 필요 data 유효 확인
    const {
      contentInfo: { refundRule = '' },
    } = TMON.oApp.htStorage.htStaticData.htDealContentInfo;
    if (!refundRule) {
      return;
    }

    this.welWrapper = $('#_wrapRefundRule');

    this.setEvent();
    this.render();
  }

  setEvent() {
    // toggle eventListener 등록
    this.welWrapper.on('click', '[data-role=toggleButton]', this.onClickToggle);
    // 링크 클릭시 eventListener 등록
    this.welWrapper.on('click', 'a', this.onClickLink);
  }

  clearEvent() {
    if (this.welWrapper) {
      this.welWrapper.off('click', '[data-role=toggleButton]');
      if (TMON.view_mode === 'app') {
        this.welWrapper.off('click', 'a');
      }
    }
  }

  /**
   * toggle eventListener
   */
  onClickToggle = e => {
    $(e.currentTarget).toggleClass('open');
  };

  /**
   * 링크 클릭시 eventListener
   */
  onClickLink = e => {
    // html protocol 변경으로 인해 beforeunload event를 발생시키는 것을 방지
    TMON.oApp.setStorage('bBlockWindowUnloadEvent', true);

    // 앱에서 링크 이동
    if (TMON.view_mode === 'app') {
      TMON.app.callApp(
        'webview',
        'showNaviWebView',
        '티몬',
        TMON.util.aup($(e.currentTarget).attr('href'), TMON.sAppQuery),
        false,
        false,
        true
      );

      e.preventDefault();
    }
  };

  render() {
    const {
      contentInfo: { refundRule = '' },
    } = TMON.oApp.htStorage.htStaticData.htDealContentInfo;

    const sHtml = `<div class="bx_ct">
                <div class="ct_wrp">
                    <button type="button" data-role="toggleButton" class="toggle tit_align_top ${'open'}"><h4>취소/환불 규정</h4></button>
                    <div class="ct slide-ct">
                        <div class="lst_plain">${refundRule}</div>
                    </div>
                </div>
            </div>`;

    this.welWrapper.html(sHtml);
  }
}
